"use client";

import React, { useState, useEffect } from 'react';

const HeaderSpacer: React.FC = () => {
  const [bannerHeight, setBannerHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // 检测移动端
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    // 监听横幅状态变化
    const handleBannerClosed = () => {
      setBannerHeight(0);
    };

    const handleBannerOpened = () => {
      setBannerHeight(isMobile ? 40 : 48); // 移动端40px，桌面端48px
    };

    // 检查横幅是否显示
    const checkBannerVisibility = () => {
      const banner = document.querySelector('.announcement-banner-fixed');
      if (banner && banner.getBoundingClientRect().top >= 0) {
        handleBannerOpened();
      } else {
        handleBannerClosed();
      }
    };

    window.addEventListener('banner-closed', handleBannerClosed);
    window.addEventListener('banner-opened', handleBannerOpened);
    
    // 初始检查
    setTimeout(checkBannerVisibility, 100);

    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('banner-closed', handleBannerClosed);
      window.removeEventListener('banner-opened', handleBannerOpened);
    };
  }, [isMobile]);

  // 计算总高度：header高度 + 横幅高度
  const headerHeight = isMobile ? 56 : 64; // 移动端56px，桌面端64px
  const totalHeight = headerHeight + bannerHeight;

  return (
    <div 
      className="w-full transition-all duration-500 ease-in-out"
      style={{ 
        height: `${totalHeight}px`,
        minHeight: `${totalHeight}px`
      }}
    />
  );
};

export default HeaderSpacer; 